import { useLocalization } from "@shared-ui/localization-context";

import { JumplinkablePageType } from "stores/DXStore";
import { JumplinkItem, JumplinksFTNodeOptions } from "./typings";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

enum ModuleType {
  DESTINATION_DESCRIPTION_MODULE = "destination-description",
  DESTINATION_VIDEO_MODULE = "destination-video",
  TE_NEIGHBORHOOD_MODULE = "te-neighborhood",
  HOTELS_MODULE = "hotels",
  DESTINATION_ATTRACTIONS_MODULE = "destination-attractions",
  DESTINATION_USER_REVIEWS_MODULE = "destination-user-reviews",
  TE_ARTICLE_MODULE = "te-article",
  TE_SIMILAR_DESTINATION_MODULE = "te-similar-destination",
}

// TODO: clean up when localized jumplink names are available from flex modules
export const getJumplinkLocalizedNames = (jumplink: JumplinkItem) => {
  const { pageType, moduleName } = jumplink;

  if (pageType === JumplinkablePageType.DX_WHERE_TO_STAY) {
    return moduleName;
  }

  const { formatText } = useLocalization();

  switch (moduleName) {
    case ModuleType.DESTINATION_DESCRIPTION_MODULE:
      return formatText("jumplinks.overview");
    case ModuleType.DESTINATION_VIDEO_MODULE:
      return formatText("jumplinks.video");
    case ModuleType.TE_NEIGHBORHOOD_MODULE:
      return formatText("jumplinks.whereToStay");
    case ModuleType.HOTELS_MODULE:
      return formatText("jumplinks.hotels");
    case ModuleType.DESTINATION_ATTRACTIONS_MODULE:
      return formatText("jumplinks.thingsToDo");
    case ModuleType.DESTINATION_USER_REVIEWS_MODULE:
      return formatText("jumplinks.reviews");
    case ModuleType.TE_ARTICLE_MODULE:
      return formatText("jumplinks.blogs");
    case ModuleType.TE_SIMILAR_DESTINATION_MODULE:
      return formatText("jumplinks.similarDestinations");
    default:
      throw new Error(`Jumplinkable module is undefined: ${moduleName}`);
  }
};

export const getJumplinkTitleString = (options: JumplinksFTNodeOptions, context: ExtendedContextStore) => {
  const { title } = options;
  const { location } = context.searchContext;
  const { formatText } = useLocalization();
  const locationName = location.localizedName || location.defaultName || location.name;

  return title || formatText("jumplinks.discover", locationName);
};
